/**
 * Trail colours.
 *
 * Dogs carry a colour their owner picked, stored as a packed ARGB integer;
 * hunters have none, so the viewer assigns one. The palette below is the same
 * sixteen values the mobile replay offers, in the same order, so a dog whose
 * colour was picked on the phone renders identically here and a hunt looks the
 * same on both.
 */
const REPLAY_PALETTE = [
  '#649696',
  '#6496C8',
  '#C85555',
  '#FA6400',
  '#FA00C8',
  '#E91E63',
  '#9C27B0',
  '#3F51B5',
  '#2196F3',
  '#4CAF50',
  '#CDDC39',
  '#AAFFC3',
  '#FFE119',
  '#9A6324',
  '#EB914E',
  '#42555B',
] as const

/** Converts a packed ARGB integer to a CSS colour, dropping the alpha channel. */
export function argbToCss(argb: number): string {
  // Alpha is dropped rather than carried into rgba(): a half-transparent trail
  // over aerial imagery is unreadable, and the stored alpha is almost always
  // fully opaque anyway.
  const rgb = (argb & 0xffffff).toString(16).padStart(6, '0')
  return `#${rgb.toUpperCase()}`
}

/**
 * A stable colour for a participant with none of their own.
 *
 * Keyed on position in the roster rather than a hash of the id, so the colours in
 * one hunt are spread across the palette instead of clustering by chance.
 */
export function paletteColor(index: number): string {
  return REPLAY_PALETTE[index % REPLAY_PALETTE.length]
}
